import styled from "styled-components";

export const WrapArea = styled.div`
	padding: 6px 0px;
	margin-bottom: 5px;
	white-space: pre-wrap;
`;
